






































































































import { Component, Vue, Watch, Mixins } from "vue-property-decorator";
import { EasyAppAPI } from "../../../api";
import { Utils } from "@/mixins";
import { Globals } from "../globals";
import { 
  getAssetPath, switchTheme, storeTheme, loadTheme, 
  clearTheme, validTheme 
} from "../utils";
import * as AppApi from "../../../api";
import {connect} from '../WebSocketService';

@Component
export default class Login extends Mixins(Utils) {
  public username: string = "";
  public password: string = "";
  public error: string | null = null;
  public processing: boolean = false;

  get logo() {
    const theme: AppApi.Theme|null = loadTheme();
    if(theme && theme.found) {
        return theme.menu_header;
    } else {
        const asset_path = getAssetPath();
        const ret = `${asset_path}img/logo.svg`;
        console.log("Header get header", ret);
        return ret;
    }
  }

  public created() {
    const token = this.$store.getters.token;
    const api = new EasyAppAPI(process.env.VUE_APP_SERVER_BASE_URL!);
    api
      .testToken(token)
      .then(() => {
        this.$router.push({ name: "my-profile" });
      })
      .catch(() => {
        this.$store.dispatch("logout");
      });
  }

  public toggleResetPassword() {
    console.log("reset_password pressed", this.$store.getters.resetPassword);
    this.$store.commit("resetPassword", !this.$store.getters.resetPassword);
  }

  public async handleSubmit() {
    this.processing = true;
    const api = new EasyAppAPI(process.env.VUE_APP_SERVER_BASE_URL!);

    try {
      const { session } = await api.login(this.username, this.password);
      const token = session;
      connect(token);

      // const authApi = new EasyAppAPI(process.env.VUE_APP_SERVER_BASE_URL!, token);
      const perms = await api.permissions();
      console.log("getting theme");
      const theme = await api.theme();
      if(validTheme(theme)) {
        storeTheme(theme);  
      } else {
        clearTheme();
      }      
      switchTheme(this);


      this.error = null;
      this.$store.dispatch("login", { token, perms });
      console.log("pushing prifile recents");
      this.$router.push({ name: "my-profile-recents" });
    } catch (err) {
      console.error("Got error", err);
      this.error = this.$t("Username or password incorrect!").toString();
    }

    this.processing = false;
  }

  get submitDisabled() {
    return this.processing || (!this.username || !this.password);
  }

  get submitText() {
    if (this.processing) {
      return this.$t("Logging in...");
    } else {
      return this.$t("Log in");
    }
  }

  get helpUrl() {
    const theme = loadTheme();
    if(theme && theme.found) {
      return theme.help_link;
    } else {
      return Globals.urls.help;
    }
  }

  get locale() {
    return this.$store.getters.locale;
  }

  set locale(locale: string) {
    this.$store.commit("setLocale", locale);
    this.$i18n.locale = this.$store.getters.locale;
  }

  @Watch("username")
  public onUsernameChanged() {
    this.error = null;
  }

  @Watch("password")
  public onPasswordChange() {
    this.error = null;
  }
}
